import React, { useEffect } from 'react'
import { useAuth0 } from '../../contexts/auth0-context'
import { connect } from 'react-redux'
import { reduxLogout } from '../../redux/actions'

function mapDispatchToProps(dispatch) {
    return {
        logoutRedux: () => dispatch(reduxLogout()),
    }
}

function ConnectedLogout(props) {
    const { logout, isLoading } = useAuth0()

    useEffect(() => {
        if (isLoading) {
            return
        }
        props.logoutRedux()
        logout({ returnTo: window.location.origin })
    }, [isLoading, logout, props])

    return <></>
}

const Logout = connect(null, mapDispatchToProps)(ConnectedLogout)

export default Logout
